import noty from '@/plugins/noty'

export const networkChangedNotification = noty({
  type: 'warning',
  timeout: 10000,
  text: 'Your Internet connection has changed. This can result in dropped calls, please contact your IT team for assistance.'
})



// WEBPACK FOOTER //
// ./src/components/rep-call/network-change-detector/notifications.js